import React from "react";
import { FiCheck } from "react-icons/fi";
import styles from "./FormSteps.module.scss";

export interface Step {
  title: string;
  description?: string;
  disabled?: boolean;
  done?: boolean;
}

interface FormStepsProps {
  steps: Step[];
  activeStep: number;
  setStep: (step: number) => void;
  className?: string;
  doneStep?: number;
}

const FormSteps: React.FC<FormStepsProps> = ({
  steps,
  activeStep,
  setStep,
  className,
  doneStep,
}) => {
  // Calculate the highest step a user can navigate to
  const highestPermittedStep = Math.max(
    doneStep !== undefined ? doneStep : 0,
    activeStep === 1 ? 1 : activeStep
  );

  return (
    <div className={`${styles.stepsContainer} ${className || ""}`}>
      {steps.map((step, index) => {
        const stepNumber = index + 1;
        const isActive = activeStep === stepNumber;
        const isDone = 
          step.done || 
          (doneStep !== undefined && stepNumber < doneStep) || 
          (doneStep === undefined && activeStep > stepNumber);
        
        // Step is disabled if it's beyond the next available step
        // and not already completed
        const isDisabled = step.disabled || 
          (!isDone && stepNumber > highestPermittedStep);
        
        return (
          <div
            key={index}
            className={`${styles.stepItem} ${
              isActive ? styles.stepItemActive : ""
            } ${isDone ? styles.stepItemDone : ""} ${
              isDisabled ? styles.stepItemDisabled : ""
            }`}
            onClick={() => !isDisabled && setStep(stepNumber)}
          >
            <div className={styles.iconContainer}>
              {isDone ? <FiCheck size={14} /> : stepNumber}
            </div>
            <div className={styles.textContainer}>
              <h5>{step.title}</h5>
            </div>
            {/* Each step item has a line extending to the right, 
                except for the last one */}
            {index < steps.length - 1 && <div className={styles.stepLine}></div>}
          </div>
        );
      })}
    </div>
  );
};

export default FormSteps; 